export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      serviceRssSetting: {
        serviceRssId: 2,
        serviceRssUuid: "servicerss002",
        rssName: "地域の広報",
        rssURL: "https://xxxxx.xxxxx.xxx"
      }
    }
  }
}